export const ClpNavBarSkeleton = () => {
  return (
    <div className={'flex justify-center clp-toc-visible:hidden'}>
      <div className={'flex h-spacing-72 w-full max-w-page items-center justify-end pr-spacing-16 md:h-spacing-88'}>
        <div className={'h-spacing-44 w-spacing-180 animate-pulse rounded-md bg-gray-300'}/>
      </div>
    </div>
  )
}
